import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';
import { getPhoneSearchFormats } from '../utils/phoneFormat';
import { calculateExactPintoMeals } from '../utils/pintoCalculator';

export const usePinto = (member) => {
  const [packages, setPackages] = useState([]);
  const [activePackage, setActivePackage] = useState(null);
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPintoPackages = async () => {
      if (!member) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        let query = supabase
          .from('pinto_packages')
          .select('*')
          .order('updated_at', { ascending: false });
          
        // Try to match by member_id first, fallback to phone
        if (member.id) {
          query = query.or(`member_id.eq.${member.id},phone.in.(${getPhoneSearchFormats(member.phone).join(',')})`);
        } else if (member.phone) {
          query = query.in('phone', getPhoneSearchFormats(member.phone));
        }

        const { data, error: err } = await query;

        if (err) throw err;

        const allPackages = data || [];
        
        const validPackages = allPackages;
        setPackages(validPackages);
        
        if (validPackages.length > 0) {
          // Auto-select the first active package, or just the first one
          const active = validPackages.find(p => p.status === 'active') || validPackages[0];
          selectPackage(active);
        } else {
          setActivePackage(null);
          setMetrics(null);
        }
      } catch (err) {
        console.error('Fetch pinto packages error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPintoPackages();
  }, [member]);

  const selectPackage = (pkg) => {
    setActivePackage(pkg);
    if (pkg) {
      setMetrics(calculateExactPintoMeals(pkg));
    } else {
      setMetrics(null);
    }
  };

  return { 
    packages, 
    activePackage, 
    metrics, 
    loading, 
    error,
    selectPackage 
  };
};
